var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outcard culist-table"},[_c('h2',[_vm._v("当前在线用户列表（"+_vm._s(_vm.items.length)+"）")]),_c('div',{staticClass:"cardin"},[_c('tableAndPage',{attrs:{"outerColumns":_vm.columns,"totalData":_vm.items}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }